module.exports = __webpack_public_path__ + "img/1440.d49939aa.svg";